import Container from "./containers/Container";

const Profile = {
  Container,
};

export { Profile };
